export const LOCALES = ["en", "fr", "de", "es"];
export const DEFAULT_LOCALE = "en";
export const PREFIXED_LOCALES = ["fr", "de", "es"];

export const SITE_URL = "https://pokegrid.net";
export const STORAGE_KEY = "pokegrid.lang";

export const OG_LOCALE = {
  en: "en_US",
  fr: "fr_FR",
  de: "de_DE",
  es: "es_ES",
};

export const LANGUAGE_NAMES = {
  en: "English",
  fr: "Français",
  de: "Deutsch",
  es: "Español",
};

// "/" and "/privacy" become "/fr" and "/fr/privacy" for French; English has no prefix
export function localePath(locale, path = "/") {
  if (locale === DEFAULT_LOCALE) {
    return path;
  }

  return path === "/" ? `/${locale}` : `/${locale}${path}`;
}

export function absoluteUrl(path) {
  return `${SITE_URL}${path}`;
}

// Next page path ("/fr/[date]") to locale
export function localeFromPagePath(path) {
  const segment = path.split("/")[1];

  return PREFIXED_LOCALES.includes(segment) ? segment : DEFAULT_LOCALE;
}
